import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-unionbank-installment-terms-modal',
  templateUrl: './unionbank-installment-terms-modal.component.html',
  styleUrls: ['./unionbank-installment-terms-modal.component.scss']
})
export class UnionbankInstallmentTermsModalComponent implements OnInit {
  public formGroup: FormGroup;
  public options: object[] = [];

  @Input() availableTerms: any;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) { }

  ngOnInit() {
    this.options = String(this.availableTerms || '')
      .split(',')
      .map(term => term.trim())
      .filter(term => term.length > 0)
      .map(term => this.getUnionbankEnumObject(term))
      .filter(option => !!option);

    this.formGroup = this.fb.group({
      unionbankInstallmentTerm: [null, Validators.required]
    });
  }

  get unionbankInstallmentTerm() {
    return this.formGroup.get('unionbankInstallmentTerm');
  }

  proceed() {
    this.activeModal.close(this.unionbankInstallmentTerm.value);
  }

  private getUnionbankEnumObject(term: string) {
    switch (term) {
      case '3': return { value: 'UNIONBANK_INSTALLMENT_3M', label: 'UnionBank 0% Installment (3 Months)' };
      case '6': return { value: 'UNIONBANK_INSTALLMENT_6M', label: 'UnionBank 0% Installment (6 Months)' };
      case '9': return { value: 'UNIONBANK_INSTALLMENT_9M', label: 'UnionBank 0% Installment (9 Months)' };
      case '12': return { value: 'UNIONBANK_INSTALLMENT_12M', label: 'UnionBank 0% Installment (12 Months)' };
      case '18': return { value: 'UNIONBANK_INSTALLMENT_18M', label: 'UnionBank 0% Installment (18 Months)' };
      case '24': return { value: 'UNIONBANK_INSTALLMENT_24M', label: 'UnionBank 0% Installment (24 Months)' };
      case '36': return { value: 'UNIONBANK_INSTALLMENT_36M', label: 'UnionBank 0% Installment (36 Months)' };
    }
  }
}
